import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { loadScoringCategoryOptions } from "../../actionCreators";
import { connect } from "react-redux";
import * as editableDocument from "utils/model/editableDocument";
import flow from "lodash.flow";
import { collection } from "utils/immutable";
import { when, both, propChanged, prop, isNumber } from "utils/fn-combinators";
import { FakeText } from "@totalsoft/rocket-ui";

//inner components
import ScoringCategoryListComponent from "./ScoringCategoryListComponent";

const findCategoryOptionByValue = (categoryOptions, scoringCategoryId, value) =>
  categoryOptions.find(
    option => option.scoringCategoryId === scoringCategoryId && option.minValue <= value && option.maxValue >= value
  );

const getItemBusinessRules = ({ categoryOptions }) => ({
  value: when(both(propChanged("option"), isNumber(prop("option.minValue"))), prop("option.minValue")),
  option: when(propChanged("value"), category =>
    findCategoryOptionByValue(categoryOptions, category.scoringCategoryId, category.value)
  ),
  score: when(both(propChanged("option"), isNumber(prop("option.score"))), prop("option.score"))
});

class ScoringCategoryListContainer extends PureComponent {
  state = {
    loading: false,
    prevPropsCategoryList: null,
    categoryList: null
  };

  static getDerivedStateFromProps(props, state) {
    if (props.categoryList !== state.prevPropsCategoryList) {
      return {
        prevPropsCategoryList: props.categoryList,
        categoryList: props.categoryList.map(editableDocument.create)
      };
    }
    return null;
  }

  componentDidMount() {
    this.loadCategoryOptions();
  }

  loadCategoryOptions = () => {
    this.props.actions.loadScoringCategoryOptions();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.categoryOptions !== this.props.categoryOptions) {
      this.loadCategoryOptions();
    }
  }

  changeItemProperty = (index, prop, value) => {
    this.setState(prevState => ({
      categoryList: collection.update(
        index,
        flow(
          editableDocument.update(prop, value, getItemBusinessRules(this.props)),
          editableDocument.validate(null, true)
        ),
        prevState.categoryList
      )
    }));
  };

  render() {
    const { categoryOptions, disabled, isHistory } = this.props;
    const { categoryList, loading } = this.state;
    return loading || !categoryList ? (
      <FakeText lines={6} />
    ) : (
      <ScoringCategoryListComponent
        onPropertyItemChange={this.changeItemProperty}
        categoryOptions={categoryOptions}
        categoryList={categoryList}
        disabled={disabled}
        isHistory={isHistory}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    categoryOptions: state.dictionaries.scoringCategoryOptions
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadScoringCategoryOptions
      },
      dispatch
    )
  };
}

ScoringCategoryListContainer.propTypes = {
  documentScoringGridId: PropTypes.number,
  scoringClassificationId: PropTypes.number.isRequired,
  categoryList: PropTypes.array.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  isHistory: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(ScoringCategoryListContainer);
